import React, { useState } from 'react';
import './Accordion.css';

export const Accordion = (props) => {
    const { content } = props;
    const [activeIndex, setActiveIndex] = useState(-1);

    return (
        <div className="accordion">
            {content && content.map((c, k) => {
                const isShown = k === activeIndex;

                return (
                    <div className="accordionItem" key={k}>
                        <div className="accordionItemContainer">
                            <dt>
                                <button
                                    className={`accordionItemButton ${isShown ? 'active' : ''}`}
                                    aria-expanded={isShown}
                                    aria-controls={`accordionItem-${k}`}
                                    onClick={() => setActiveIndex(isShown ? -1 : k)}
                                    onTouchEnd={() => setActiveIndex(isShown ? -1 : k)}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        {c.icon && (
                                            <div className="accordionIcon">{c.icon}</div>
                                        )}
                                        {c.title}
                                    </div>
                                    <span style={{ transform: isShown ? 'rotate(270deg)' : 'rotate(90deg)', transition: 'transform 0.2s' }}>
                                        ➜
                                    </span>
                                </button>
                            </dt>
                            {isShown && (
                                <dd id={`accordionItem-${k}`}>
                                    {c.listElements}
                                </dd>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
